module.exports = __webpack_public_path__ + "img/blog-02.70fae66f.jpg";